import { useEffect, useState, useCallback, useRef } from "react";
import axios from "axios";
import data from "./data";
import { columns, dataForm } from "./formColumn";
import { ICONS } from "@/assets";

import {
  ConfigProvider,
  Space,
  Table,
  Button,
  Input,
  Pagination,
  Select,
  Spin,
  message,
  Tag,
} from "antd";

import EmployeeModal from "@/components/EmployeeModal";
import CustomForm from "@/components/customformuser"; // pastikan path ini benar
import ButtonExportExcel from "@/components/ButtonExportExcel";

const API_BASE = import.meta.env.VITE_BASE_URL;
const API_BASE2 = import.meta.env.VITE_BASE_URL2;

const MasterEmployee = () => {
  const formRef = useRef(null); // <-- ref ke form

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [meta, setMeta] = useState({
    total: 0,
    page: 1,
    limit: 10,
    totalPages: 1,
  });

  const [modalType, setModalType] = useState(null);
  const [selectedData, setSelectedData] = useState(null);

  const [q, setQ] = useState("");
  const [roleFilter, setRoleFilter] = useState(null);

  const [formSchema, setFormSchema] = useState([]);

  useEffect(() => {
    fetchCabang();
  }, []);

  const fetchCabang = async () => {
    try {
      const resp = await axios.get(`${API_BASE2}/api/cabang`); // sesuaikan endpoint
      const payload = resp.data?.data || resp.data;

      console.log("payload ==>", payload);
      const options = payload.cabang.map((c) => ({
        value: c.cabang,
        label: c.cabang,
      }));

      // console.log("list res ==>", res.data);
      console.log("list cabang ==>", options);

      injectOptions("cabang", options);
    } catch (err) {
      console.error("Gagal load cabang:", err);
    }
  };

  const injectOptions = (key, options) => {
    setFormSchema((prev) =>
      dataForm.map((row) =>
        row.map((field) => (field.key === key ? { ...field, options } : field))
      )
    );
  };

  const closeModal = () => {
    setModalType(null);
    setSelectedData(null);
    // optionally reset form
    if (formRef.current && formRef.current.reset) formRef.current.reset();
  };

  const handleModal = (type, record = null) => {
    setModalType(type);
    setSelectedData(record);
  };

  const actionColumn = {
    title: "Action",
    key: "action",
    render: (_, record) => (
      <Space size="middle">
        <button onClick={() => handleModal("view", record)}>
          <img src={ICONS.FaDetail} alt="View" />
        </button>

        <button onClick={() => handleModal("edit", record)}>
          <img src={ICONS.FaEdit} alt="Edit" />
        </button>

        <button onClick={() => handleModal("delete", record)}>
          <img src={ICONS.FaTrash} alt="Delete" />
        </button>
      </Space>
    ),
  };

  const columnsWithRenderer = columns.map((col) => {
    if (col.dataIndex === "is_active") {
      return {
        ...col,
        render: (val, record) => {
          const active = typeof val !== "undefined" ? val : !!record?.is_active;
          return active ? (
            <span style={{ color: "green", fontWeight: 600 }}>Active</span>
          ) : (
            <span style={{ color: "red", fontWeight: 600 }}>Inactive</span>
          );
        },
      };
    }
    return col;
  });

  const extendedColumn = [...columnsWithRenderer, actionColumn];

  const normalizeIsActive = (val) => {
    if (val === true || val === "true" || val === 1 || val === "1") return true;
    return false;
  };

  const roleOptions = [
    { value: "approver1", label: "Approver 1" },
    { value: "approver2", label: "Approver 2" },
    { value: "approver3", label: "Approver 3" },
    { value: "cmo", label: "CMO" },
    { value: "credit_analyst", label: "Credit Analyst" },
    { value: "admin", label: "Admin" },
    { value: "admin_operation", label: "Admin Operation" },
    { value: "IT", label: "IT" },
    { value: "viewer", label: "Viewer" },
  ];

  const fetchUsers = useCallback(
    async (page = meta.page, limit = meta.limit, qParam = q, roleParam = roleFilter) => {
      try {
        setLoading(true);
        const params = { page, limit };
        if (qParam) params.q = qParam;
        if (roleParam) params.role = roleParam;

        const resp = await axios.get(`${API_BASE}/api/user/users`, { params });
        const payload = resp.data?.data || resp.data;

        if (payload) {
          const usersRaw = payload.users || [];
          const normalized = usersRaw.map((u) => ({
            ...u,
            is_active: normalizeIsActive(u?.is_active),
          }));

          setUsers(normalized);
          const newMeta = payload.meta || {
            total: normalized.length,
            page,
            limit,
            totalPages: Math.ceil(normalized.length / limit),
          };
          setMeta({
            total: newMeta.total || normalized.length,
            page: newMeta.page || page,
            limit: newMeta.limit || limit,
            totalPages:
              newMeta.totalPages ||
              Math.ceil((newMeta.total || normalized.length) / limit),
          });
          // debug log (bisa dihapus)
          console.log("fetchUsers -> sample:", normalized.slice(0, 5));
        } else {
          const normalized = (resp.data || []).map((u) => ({
            ...u,
            is_active: normalizeIsActive(u?.is_active),
          }));
          setUsers(normalized);
          setMeta({
            total: normalized.length,
            page,
            limit,
            totalPages: Math.ceil(normalized.length / limit),
          });
        }
      } catch (err) {
        console.error("fetchUsers error", err);
        message.error("Gagal mengambil data users");
      } finally {
        setLoading(false);
      }
    },
    [API_BASE, meta.limit, meta.page, q, roleFilter]
  );

  useEffect(() => {
    fetchUsers(1, meta.limit, q);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onPageChange = (page, pageSize) => {
    fetchUsers(page, pageSize, q);
  };

  // handleSubmit sekarang two-mode:
  // - dipanggil tanpa arg: trigger formRef.submit()
  // - dipanggil dengan values: lakukan POST/PUT
  const handleSubmit = async (values) => {
    if (typeof values === "undefined" || values === null) {
      if (formRef.current && typeof formRef.current.submit === "function") {
        formRef.current.submit();
      } else {
        message.error("Form belum siap, coba lagi.");
      }
      return;
    }

    try {
      setLoading(true);
      const payload = { ...values };
      // jika backend mau 0/1: payload.is_active = payload.is_active ? 1 : 0;

      if (modalType === "add") {
        await axios.post(`${API_BASE}/api/user/users`, payload);
        message.success("User berhasil ditambahkan");
      } else if (modalType === "edit" && selectedData?.id) {
        await axios.put(
          `${API_BASE}/api/user/users/${selectedData.id}`,
          payload
        );
        message.success("User berhasil diupdate");
      }
      closeModal();
      fetchUsers(meta.page, meta.limit, q);
    } catch (err) {
      console.error("submit error", err);
      message.error("Gagal menyimpan user");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!selectedData?.id) {
      message.error("Tidak ada data yang dipilih");
      return;
    }
    try {
      setLoading(true);
      await axios.delete(`${API_BASE}/api/user/users/${selectedData.id}`);
      message.success("User berhasil dihapus");
      closeModal();
      const newTotal = Math.max(0, meta.total - 1);
      const newTotalPages = Math.max(1, Math.ceil(newTotal / meta.limit));
      const newPage = meta.page > newTotalPages ? newTotalPages : meta.page;
      fetchUsers(newPage, meta.limit, q);
    } catch (err) {
      console.error("delete error", err);
      message.error("Gagal menghapus user");
    } finally {
      setLoading(false);
    }
  };

  // const renderContent = () => {
  //   if (modalType === "view") {
  //     return <CustomForm ref={formRef} formColumn={dataForm} selectedData={selectedData} readOnly showInternalButtons={false} />;
  //   } else if (modalType === "add") {
  //     return <CustomForm ref={formRef} formColumn={dataForm} showInternalButtons={false} />;
  //   } else if (modalType === "edit") {
  //     return <CustomForm ref={formRef} formColumn={dataForm} selectedData={selectedData} showInternalButtons={false} />;
  //   }
  //   return null;
  // };

  // pastikan ada: const formRef = useRef(null);
  // dan handleSubmit di scope komponen

  // if (col.type === "select") {
  //   return (
  //     <Form.Item
  //       key={col.key}
  //       name={col.key}
  //       label={col.label}
  //       rules={col.rules}
  //     >
  //       <Select placeholder={col.placeholder} disabled={readOnly}>
  //         {col.options?.map((opt) => (
  //           <Select.Option key={opt.value} value={opt.value}>
  //             {opt.label}
  //           </Select.Option>
  //         ))}
  //       </Select>
  //     </Form.Item>
  //   );
  // }

  const renderContent = () => {
    if (modalType === "view") {
      return (
        <CustomForm
          ref={formRef}
          formColumn={dataForm}
          selectedData={selectedData}
          readOnly
          showInternalButtons={false}
          // no need onSubmit for readOnly mode
        />
      );
    } else if (modalType === "add") {
      return (
        <CustomForm
          ref={formRef}
          formColumn={formSchema}
          showInternalButtons={false}
          onSubmit={handleSubmit} // <<< pass handler here
        />
      );
    } else if (modalType === "edit") {
      return (
        <CustomForm
          ref={formRef}
          formColumn={formSchema}
          selectedData={selectedData}
          showInternalButtons={false}
          onSubmit={handleSubmit} // <<< and here
        />
      );
    }
    return null;
  };

  return (
    <div>
      <h1 className="text-4xl font-semibold mb-8">Master Employee Page</h1>

      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center gap-4">
          <Button
            type="primary"
            size="large"
            onClick={() => handleModal("add", null)}
            className="bg-green-600 text-white py-2 px-4 rounded-md mb-4"
          >
            Tambah Data
          </Button>
          <ButtonExportExcel />
        </div>

        <div className="flex items-center gap-2">
          <Select
            allowClear
            placeholder="Filter by Role"
            style={{ width: 180 }}
            options={roleOptions}
            value={roleFilter}
            onChange={(val) => {
              setRoleFilter(val ?? null);
              fetchUsers(1, meta.limit, q, val ?? null);
            }}
          />
          <Input.Search
            placeholder="Cari nama / username / email"
            allowClear
            enterButton
            onSearch={(val) => {
              setQ(val);
              fetchUsers(1, meta.limit, val, roleFilter);
            }}
            style={{ width: 320 }}
          />
        </div>
      </div>

      <ConfigProvider
        theme={{
          components: {
            Table: {
              colorPrimary: "#0164A2",
              headerColor: "#fff",
              headerBg: "#0164A2",
              headerBorderRadius: 6,
              algorithm: true,
            },
            Pagination: {
              colorPrimary: "#0164A2",
              colorPrimaryHover: "#0164A2",
              colorPrimaryBorder: "#0164A2",
              algorithm: true,
            },
          },
        }}
      >
        <div style={{ position: "relative" }}>
          {loading && (
            <div
              style={{ position: "absolute", zIndex: 20, right: 16, top: 16 }}
            >
              <Spin />
            </div>
          )}

          <Table
            columns={extendedColumn}
            dataSource={users.length ? users : data}
            size="middle"
            rowKey="id"
            pagination={false}
            loading={loading}
            className={users.length === 0 ? `shadow-md` : ""}
          />
        </div>

        <div className="flex justify-end mt-4">
          <Pagination
            current={meta.page}
            pageSize={meta.limit}
            total={meta.total}
            onChange={onPageChange}
            showSizeChanger
            onShowSizeChange={(current, size) => fetchUsers(1, size, q)}
            pageSizeOptions={[10, 25, 50, 100]}
            showTotal={(total) => `Total ${total} items`}
          />
        </div>
      </ConfigProvider>

      {/* Modal Add */}
      <EmployeeModal
        visible={modalType === "add"}
        onClose={closeModal}
        title="Add User"
        formRef={formRef}
        submitText="Tambah"
        showFooter={true}
      >
        {renderContent()}
      </EmployeeModal>

      {/* Modal View */}
      <EmployeeModal
        visible={modalType === "view"}
        onClose={closeModal}
        title="View User"
        readOnly={true}
        showFooter={false}
      >
        {renderContent()}
      </EmployeeModal>

      {/* Modal Edit */}
      <EmployeeModal
        visible={modalType === "edit"}
        onClose={closeModal}
        title="Edit User"
        formRef={formRef}
        submitText="Save Changes"
        showFooter={true}
      >
        {renderContent()}
      </EmployeeModal>

      {/* <EmployeeModal visible={modalType === "delete"} onClose={closeModal} title={`Delete User ${selectedData?.username ?? ""} - ${selectedData?.name ?? ""}`} content={<p>Are you sure you want to delete this user?</p>} showFooter={true} onDelete={handleDelete} submitText="Delete" /> */}
      <EmployeeModal
        visible={modalType === "delete"}
        onClose={closeModal}
        title={`Delete User ${selectedData?.username ?? ""} - ${
          selectedData?.name ?? ""
        }`}
        onDelete={handleDelete}
        showFooter={true}
      >
        <p>Are you sure you want to delete this user?</p>
      </EmployeeModal>
    </div>
  );
};

export default MasterEmployee;
